import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  REPORTING_CHARGEBACK,
  NOTIFICATION,
} from '../actionTypes';

const fetchChargebackReporting = async (payload) => {
  const params = payload.payload;
  if (params?.query) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_DISPUTES}${params.query}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_DISPUTES}`);
};

export function* getChargebackReporting(action) {
  try {
    const { data } = yield call(fetchChargebackReporting, action.payload);
    yield put({ type: REPORTING_CHARGEBACK.SUCCESS, payload: data });
  } catch (e) {
    yield put({ type: REPORTING_CHARGEBACK.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
